const SERVER_OPTIONS = ['http://localhost:8080/', 'https://disc-golf-server.herokuapp.com/']; // Keep Heroku URL Up-to-date...
export const SERVER_URL = SERVER_OPTIONS[1];
export const NAMESPACE = '/discgolf';


// WEBPACK FOOTER //
// ./src/.config.js